import React from 'react';
import { useAppContext } from '../../context/AppContext';
import SectionTitle from '../SectionTitle';
import CheckboxGroup from '../CheckboxGroup';

const featureOptions = [
  { value: 'responsiveDesign', label: 'Responsive Design' },
  { value: 'animations', label: 'Smooth Animations' },
  { value: 'darkMode', label: 'Dark Mode Support' },
  { value: 'auth', label: 'User Authentication' },
  { value: 'search', label: 'Search Functionality' },
  { value: 'realTime', label: 'Real-time Updates' },
];

const pageOptions = [
  { value: 'landing', label: 'Landing Page' },
  { value: 'about', label: 'About Us' },
  { value: 'contact', label: 'Contact Page' },
  { value: 'privacy', label: 'Privacy Policy' },
  { value: 'terms', label: 'Terms of Service' },
];

function Step4FeaturesPages() {
  const { projectDraft, dispatch } = useAppContext();

  const handleFeatureChange = (selectedValues) => {
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { features: selectedValues } });
  };
  
  const handlePageChange = (selectedValues) => {
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { pages: selectedValues } });
  };

  return (
    <div className="space-y-8">
      <SectionTitle title="Features & Pages" subtitle="Select the features and pages to include in your project." />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
          <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
            <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
            Core Features
          </h3>
          <CheckboxGroup
            options={featureOptions}
            selectedValues={projectDraft.features || []}
            onChange={handleFeatureChange}
          />
        </div>
        
        <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-200">
          <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
            <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
            Standard Pages
          </h3>
          <CheckboxGroup
            options={pageOptions}
            selectedValues={projectDraft.pages || []}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}

export default Step4FeaturesPages;